import { getPathToPosition } from '../../utils/getReachablePath/index.js';
import positionToStringId from '../../utils/positionToStringId.js';
function getCommandToBlockPathToAgentUnit(agentUnit, agentFreshUnitsNotInDanger, targetPosition, rankedPositionsById, hexProperties, rules, gameState, mapHexes) {
    for (const unitNotInDanger of agentFreshUnitsNotInDanger) {
        const distanceToAgent = hexProperties.getDistance(unitNotInDanger.position, agentUnit.position);
        if (distanceToAgent === 1) {
            const currentRank = rankedPositionsById[positionToStringId(unitNotInDanger.position)]?.rank ?? 0;
            const targetRank = rankedPositionsById[positionToStringId(targetPosition)]?.rank ?? 0;
            if (currentRank <= targetRank) {
                continue;
            }
        }
        const pathToPosition = getPathToPosition(unitNotInDanger, targetPosition, hexProperties, rules, gameState.units, mapHexes);
        if (pathToPosition && pathToPosition.length) {
            return {
                agentUnit: unitNotInDanger,
                targetPosition: targetPosition,
                pathToTargetPosition: pathToPosition,
                targetEnemy: null,
            };
        }
    }
    return null;
}
export default getCommandToBlockPathToAgentUnit;
